jQuery(document).ready(function($) {
    $(window).on('load', function() {
        AOS.init();
    });

    $('.evaluation-slider').slick({
        infinite: true,
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '15%',
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [{
            breakpoint: 769,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        }]
    });

    $("#topBtn").hide();
    $(window).on("scroll", function() {
        if ($(this).scrollTop() > 300) {
            $("#topBtn").fadeIn("fast");
        } else {
            $("#topBtn").fadeOut("fast");
        }
    });
    $('#topBtn').click(function() {
        $('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });

    $(document).on('click', 'a[href^="#"]', function(event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 100
        }, 500);
    });
})